// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"f92cc191","117":"1ed6df49","255":"3c95bea8","488":"2e6ce3dd","581":"41b02c2a","681":"6baa2a8f","735":"69491d15","913":"974236a2"}[chunkId] + ".chunk.js";
};